import { getCategoriesChain, getSectionById } from '@/entities/categories'

import { TSection } from '@/shared/types/deprecated-types'
import { TProduct } from '@/shared/types/product-types'

export const getProductPageView = (product: TProduct, allCategories: TSection[]): Record<string, unknown> | null => {
	const productCategory = getSectionById(allCategories, product.SECTION_ID)
	const categoriesChain = getCategoriesChain(productCategory, allCategories)

	return {
		event: 'product_view',
		ecommerce: {
			currencyCode: 'RUB',
			detail: {
				products: [
					{
						id: product.KOD,
						name: product.TITLE,
						price: product.PRICE.VALUE,
						brand: product.PROPERTIES?.osnovnye_parametry?.GROUP_PROPERTIES?.PROIZVODITEL?.values[0],
						category: categoriesChain
					}
				]
			}
		}
	}
}
